import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        training: '='
    },
    template: `
        <div class="heading01 type01">
            <h4>{{ 'occurrence.Participants' | translate }}</h4>
            <a ng-if="vm.showAssignParticipants" class="btn add" ng-click="vm.assignParticipants()">{{ 'occurrence.Assign participants' | translate }}</a>
        </div>
        <div class="alert alert-plain" ng-if="!vm.time.participantIds.length">
            <h3>{{ 'general.This table has no content yet' | translate }}</h3>
            <p>{{ 'general.Please add some content' | translate }}</p>
        </div>
        <table class="data01" ng-if="vm.time.participantIds.length">
            <thead>
                <tr>
                    <th ng-if="vm.showBulkAction">
                        <input ng-model="vm.checked" ng-click="vm.toggleAll()" type="checkbox">
                    </th>
                    <th>{{ 'occurrence.User' | translate }}</th>
                    <th ng-if="vm.isPublished">{{ 'occurrence.Participated' | translate }}</th>
                    <th ng-if="vm.isTestTraining">{{ 'occurrence.Collected points' | translate }}</th>
                    <th ng-if="vm.isTestTraining">{{ 'occurrence.Status' | translate }}</th>
                    <th ng-if="vm.isPublished">{{ 'occurrence.Signature' | translate }}</th>
                    <th ng-if="vm.isPublished" class="nosort">&nbsp;</th>
                    <th ng-if="vm.isPublished && vm.isTestTraining" class="nosort">&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="participant in vm.participants" ng-class="{ status04: participant.isInActive }">
                    <td ng-if="vm.showBulkAction">
                        <input ng-disabled="!vm.canManageOccurrences" type="checkbox"
                        ng-checked="vm.hasParticipantId(participant.userId)"
                        ng-click="$event.stopPropagation();vm.toggleParticipantId(participant.userId)">
                    </td>
                    <td>{{ participant.firstName }} {{participant.lastName}}<small ng-if="participant.isInActive"
                    > ({{ 'user.Inactive' | translate }})</small></td>
                    <td ng-if="vm.isPublished">
                        <span ng-if="participant.isParticipated">{{ 'general.Yes' | translate }}</span>
                        <span ng-if="!participant.isParticipated">{{ 'general.No' | translate }}</span>
                    </td>
                    <td ng-if="vm.isTestTraining">{{ participant.submissionTotalPoints }}</td>
                    <td ng-if="vm.isTestTraining">{{ vm.COURSE_TRAINING_STATUS_TYPE_ENUM.LABELS[participant.trainingProgressStatus] }}</td>
                    <td ng-if="vm.isPublished">
                        <img
                            ng-if="participant.signatureFilename"
                            ng-src="{{ vm.OccurrenceService.getSignatureThumbnailUrl(vm.time.id, participant.signatureFilename) }}" />
                    </td>
                    <td ng-if="vm.isPublished" class="actions">
                        <a ng-if="participant.signatureFilename && vm.canHandleSignature()" ng-click="vm.removeSignature(participant.userId)"
                         class="btn ico-edit">{{ 'occurrence.Remove signature' | translate }}</a>
                        <a ng-click="vm.signParticipation(participant.userId)" class="btn ico-person"
                        ng-if="!participant.signatureFilename && vm.canHandleSignature()">{{ 'occurrence.Sign' | translate }}</a>
                    </td>
                    <td ng-if="vm.isPublished && vm.isTestTraining && participant.trainingProgressStatus
                        == vm.COURSE_TRAINING_STATUS_TYPE_ENUM.KEYS.IN_ASSESSMENT" class="actions">
                        <a ui-sref="authorized.forms.validations.detail({ id: participant.trainingProgress.id })" class="btn view">{{ 'validations.Assess' | translate }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="form" ng-if="vm.showBulkAction">
            <div class="row inline" ng-if="vm.loading">
                <label class="label">{{ 'general.Loading' | translate }}...</label>
            </div>
            <div class="row inline" ng-if="!vm.loading">
                <label class="label">{{ 'occurrence.Bulk actions' | translate }}</label>
                <div class="items">
                    <select class="form-control small" ng-model="vm.bulkAction">
                        <option value="{{ vm.SCHEDULE_BULK_ACTIONS_ENUM.KEYS.MARK_AS_PARTICIPATED }}">
                            {{ 'occurrence.Mark as participated' | translate }}
                        </option>
                        <option value="{{ vm.SCHEDULE_BULK_ACTIONS_ENUM.KEYS.MARK_AS_NOT_PARTICIPATED }}">
                            {{ 'occurrence.Mark as not participated' | translate }}
                        </option>
                    </select>
                    <button class="btn bordered02" ng-if="vm.bulkIds.length" ng-click="vm.doBulkAction()">{{ 'general.Ok' | translate }}</button>
                </div>
            </div>
        </div>
        <hr ng-if="(vm.showConfirmButton || vm.showConfirmedBy) && !vm.loading">
        <ul class="actions01 nopadding" ng-if="vm.showConfirmButton && !vm.loading">
            <li>
                <a class="btn main" ng-click="vm.confirm()">{{ 'occurrence.Confirm' | translate }}</a>
            </li>
        </ul>
        <p ng-if="vm.showConfirmedBy" class="note">
            <span ng-if="vm.confirmedByMessage">{{ vm.confirmedByMessage }}</span>
        </p>
        <ul class="actions01 nopadding" ng-if="vm.showConfirmedBy && !vm.loading">
            <li>
                <a class="btn main" ng-click="vm.removeConfirmation()" ng-if="vm.canManageOccurrences">
                    {{ 'trainingTime.Remove confirmation' | translate }}
                </a>
            </li>
        </ul>
    `
})
export default class {
    constructor ($scope, $translate, lodash, toastr,
                 OccurrenceService, PrivilegeService, ModalService, MomentService,
                 OccurrenceResource, TrainingTimeResource, UserResource,
                 ROLE_PRIVILEGE_ENUM, COURSE_TRAINING_STATUS_TYPE_ENUM,
                 COURSE_TRAINING_TYPE_ENUM, SCHEDULE_BULK_ACTIONS_ENUM, FormFactory) {
        this.$scope = $scope;
        this.$translate = $translate;

        this.lodash = lodash;
        this.toastr = toastr;

        this.OccurrenceService = OccurrenceService;
        this.PrivilegeService = PrivilegeService;
        this.ModalService = ModalService;
        this.MomentService = MomentService;

        this.OccurrenceResource = OccurrenceResource;
        this.TrainingTimeResource = TrainingTimeResource;
        this.UserResource = UserResource;

        this.FormFactory = FormFactory;

        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.COURSE_TRAINING_STATUS_TYPE_ENUM = COURSE_TRAINING_STATUS_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.SCHEDULE_BULK_ACTIONS_ENUM = SCHEDULE_BULK_ACTIONS_ENUM;

        this.parentScope = $scope.$parent;
        this.$scope.$on('reload:participants', () => {
            this.$onInit();
        });
    }

    $onInit () {
        this.canManageOccurrences = this.PrivilegeService.canManageOccurrences();
        this.bulkAction = 'MARK_AS_PARTICIPATED';
        this.bulkIds = [];
        this.time = this.parentScope.vm.training.times[this.parentScope.index];
        this.occurrence = this.parentScope.vm.occurrence;
        this.isRoomOverbooked = this.parentScope.vm.isRoomOverbooked(this.time.roomId, this.time.participantIds.length);
        this.room = this.parentScope.vm.getRoom(this.time.roomId);
        this.isPublished = this.OccurrenceService.isPublished(this.occurrence);

        // find correct training time
        const tempTrainingTime = this.lodash.find(this.parentScope.vm.trainingTimesWithParticipants, { id: parseInt(this.time.id, 10) });
        // get participants from current training time or set empty array if no training time found
        this.trainingTimeParticipants = tempTrainingTime ? tempTrainingTime.courseOccurrenceTrainingTimeParticipants : [];

        this.initParticipants();
        this.showAssignParticipants = this.time.isReportConfirmed ? this.PrivilegeService.isCourseAdmin() : this.canManageOccurrences;

        // check if basic needs are set for bulk action
        const showBulk = this.time.participantIds.length && this.isPublished && this.canManageOccurrences;
        this.showBulkAction = this.time.isReportConfirmed ? this.PrivilegeService.isCourseAdmin() && showBulk : showBulk;

        this.confirmedByMessage = '';
        if (this.time.reportConfirmedBy && (this.PrivilegeService.canViewUsers() || this.PrivilegeService.canManageOccurrences())) {
            this.initConfirmedByMessage();
        }
        this.showConfirmButton = this.canManageOccurrences
            && this.isPublished
            && !this.time.isReportConfirmed
            && this.participants.length;
        this.showConfirmedBy = this.time.isReportConfirmed && this.time.reportConfirmedBy;

        this.isTestTraining = this.training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST;
        this.showAssessmentBulkActions = this.hasInAssessmentParticipants();
    }

    initParticipants () {
        this.participants = this.trainingTimeParticipants.map(participant => {
            const user = this.lodash.find(this.parentScope.vm.participants, { userId: participant.userId });
            if (user) {
                participant.isInActive = user.isInActive;
                participant.lastName = user.lastName;
                participant.firstName = user.firstName;
                return participant;
            }
            return null;
        });
        this.participants = this.lodash.orderBy(
            this.participants.filter((participant) => participant !== null),
            ['lastName', 'firstName']
        );
    }

    hasInAssessmentParticipants () {
        return this.trainingTimeParticipants
            .filter(participant => participant.trainingProgressStatus === this.COURSE_TRAINING_STATUS_TYPE_ENUM.KEYS.IN_ASSESSMENT)
            .length
        ;
    }

    initConfirmedByMessage () {
        this.UserResource.get({ id: this.time.reportConfirmedBy, privilegesCheck: 0 }).$promise
            .then((user) => {
                this.confirmedByMessage = this.$translate.instant(
                    'occurrence.confirmed_by_message', {
                        confirmedBy: user.displayName,
                        // use current date straight after confirmation, so we don't have to wait after api response
                        confirmedAt: this.MomentService.formatDate(this.time.reportConfirmedAt) || this.MomentService.getCurrentDate()
                    }
                );
            });
    }

    getTrainingTimeParticipant (id) {
        return this.lodash.find(this.trainingTimeParticipants, { userId: parseInt(id, 10) });
    }

    toggleAll () {
        this.bulkIds = this.checked ? angular.copy(this.time.participantIds) : [];
    }

    hasParticipantId (id) {
        return this.lodash.includes(this.bulkIds, id);
    }

    toggleParticipantId (id) {
        if (this.hasParticipantId(id)) {
            this.lodash.pull(this.bulkIds, id);
            this.checked = false;
        }
        else {
            this.bulkIds.push(id);
        }
    }

    assignParticipants () {
        return this.OccurrenceService.assignParticipants(
            this.occurrence,
            this.parentScope.vm.training,
            this.parentScope.index,
            this.parentScope.vm.participants,
            this.isRoomOverbooked,
            this.room
        ).then(() => {
            this.reload();
        });
    }

    confirm () {
        this.loading = true;
        this.time.isReportConfirmed = true;

        this.TrainingTimeResource.update({ id: this.time.id }, this.time).$promise
            .then(() => {
                this.reload();
                this.loading = false;
            })
            .catch(() => {
                this.loading = false;
            })
        ;
    }

    reload () {
        this.$scope.$emit('reload:training-time-participants', {
            occurrenceTrainingId: this.parentScope.vm.training.id,
            trainingTimeIndex: this.parentScope.index
        });
    }

    signParticipation (id) {
        const user = this.lodash.find(this.parentScope.vm.participants, { userId: parseInt(id, 10) });
        return this.OccurrenceService.signParticipation(user, this.time).then(() => {
            this.reload();
        })
        .catch((errors) => {
            errors.data.map((error) => this.toastr.error(error.message));
        });
    }

    removeSignature (id) {
        const user = this.lodash.find(this.parentScope.vm.participants, { id: parseInt(id, 10) });
        const message = this.$translate.instant(
            'occurrence.Confirm signature remove for participator',
            { participator: user ? user.displayName : '' }
        );
        this.ModalService.delete(message).then(() => {
            this.OccurrenceResource.setTrainingTimeParticipants(
                { id: this.time.id }, [{
                    userId: id,
                    isParticipated: 0,
                    deleteSignature: 1
                }]
            )
            .$promise
            .then(() => {
                this.reload();
            });
        });
    }

    doBulkAction () {
        const { SCHEDULE_BULK_ACTIONS_ENUM, COURSE_TRAINING_STATUS_TYPE_ENUM } = this;
        this.loading = true;
        let post = {};

        switch (this.bulkAction) {
        case SCHEDULE_BULK_ACTIONS_ENUM.KEYS.ASSESSMENT_FINISHED_TEST_PASSED:
        case SCHEDULE_BULK_ACTIONS_ENUM.KEYS.ASSESSMENT_FINISHED_TEST_FAILED: {
            let status = COURSE_TRAINING_STATUS_TYPE_ENUM.KEYS.PASSED;
            if (this.bulkAction === SCHEDULE_BULK_ACTIONS_ENUM.KEYS.ASSESSMENT_FINISHED_TEST_FAILED) {
                status = COURSE_TRAINING_STATUS_TYPE_ENUM.KEYS.NOT_PASSED;
            }
            post = {
                occurrenceTrainingId: this.parentScope.vm.training.id,
                status,
                userIds: this.bulkIds
            };
            this.OccurrenceResource.assessTestTraining(null, post)
                .$promise
                .then(() => {
                    this.loading = false;
                    this.reload();
                })
                .catch((errors) => {
                    this.loading = false;
                    errors.data.map((error) => this.toastr.error(error.message));
                });
            break;
        }
        default: {
            let isParticipated = 1;
            if (this.bulkAction === SCHEDULE_BULK_ACTIONS_ENUM.KEYS.MARK_AS_NOT_PARTICIPATED) {
                isParticipated = 0;
            }
            post = this.bulkIds.map((id) => {
                return {
                    userId: id,
                    isParticipated
                };
            });
            this.OccurrenceResource.setTrainingTimeParticipants({ id: this.time.id }, post)
                .$promise.then(() => {
                    this.loading = false;
                    this.reload();
                })
                .catch((errors) => {
                    this.loading = false;
                    errors.data.map((error) => this.toastr.error(error.message));
                });
        }
        }
    }

    canHandleSignature () {
        return (!this.time.isReportConfirmed && this.canManageOccurrences)
            || (this.time.isReportConfirmed && this.PrivilegeService.isCourseAdmin());
    }

    removeConfirmation () {
        this.loading = true;

        this.ModalService.delete(this.$translate.instant('trainingTime.You are about to remove confirmation. Are you sure you wish to continue?')).then(() => {
            this.time.isReportConfirmed = false;

            this.TrainingTimeResource.update({ id: this.time.id }, this.time).$promise
                .then(() => this.reload());
        }).finally(() => {
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/steps/schedule/trainingTimes/participants/index.js